import { motion, useInView } from "framer-motion";
import { graphql, navigate } from "gatsby";
import parse from "html-react-parser";
import React, { useEffect, useRef, useState } from "react";
import ImageOpt from "./ImageOpt";

const GetInTouch = ({ module }) => {
  const ref = useRef(null);
  const [hasPlayed, setHasPlayed] = useState(false);
  const isInView = useInView(ref);

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  };
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true);
    }
  }, [isInView, hasPlayed, setHasPlayed]);

  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    input_2: "",
    input_4: "",
    input_7: "",
  });

  const [formError, setFormError] = useState({
    input_2: "",
    input_4: "",
    input_7: "",
  });

  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const showGetInTouchThankYouMessage = () => {
    const getInTouchFormWrapper = document.querySelector(".get-in-touch-form");
    const paragraph = document.createElement("p");
    paragraph.classList.add("getintouch-message");
    paragraph.innerText =
      "Thanks for contacting us! We will get in touch with you shortly.";
    getInTouchFormWrapper.appendChild(paragraph);
  };

  if (module.hideSection === "no") {
    return (
      <motion.section
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className={`zigzag py-50 xlscreen:py-45 mdscreen:py-40 ${
          module.extraClass ? module.extraClass : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className="container-fluid-sm"
        >
          <div className="flex flex-wrap items-center">
            <motion.div
              variants={animFade}
              className="mdscreen2:w-full w-6/12 order-1 md2:order-1"
            >
              {module?.image && (
                <div className="border-bg-offwhite">
                  <div className="img portrait">
                    <ImageOpt
                      imgData={module.image.mediaItemUrl}
                      imgAlt={module.image.title}
                      imgClass=""
                      width={2000}
                      height={1000}
                      imgLoad="lazy"
                    />
                  </div>
                </div>
              )}
            </motion.div>
            <div className="mdscreen2:w-full w-6/12 md2:pl-60 xl:!pl-80 mdscreen:pt-30 order-2 md2:order-2 mdscreen2:pt-45">
              <div className="md2:max-w-[578px]">
                {module?.heading && (
                  <motion.div
                    variants={animFade}
                    className="title title-grey pt-35 mdscreen2:pt-0 uppercase"
                  >
                    <h3 className="font-500 tracking-0.04em">
                      {module.heading}
                    </h3>
                  </motion.div>
                )}
                {module?.description && (
                  <motion.div
                    variants={animFade}
                    className="content global-list pt-10"
                  >
                    {parse(module.description)}
                  </motion.div>
                )}
                <motion.div variants={animFade} className="c-form mt-35">
                  <div className="grid gap-y-[28px]">
                    <div className="form-group flex flex-col">
                      <label
                        className="uppercase text-15 font-600 mb-[7px]"
                        htmlFor="name"
                      >
                        name<span className="text-red-100">*</span>
                      </label>
                      <input
                        id="name"
                        type="text"
                        value={form.input_2}
                        onChange={(e) => {
                          setForm({
                            ...form,
                            input_2: e.target.value,
                          });
                          setFormError({
                            ...formError,
                            input_2: "",
                          });
                        }}
                        placeholder="Type here"
                      />
                      {formError.input_2 && (
                        <div className="error">
                          <span className="text-red-100 font-heading italic text-12">
                            {formError.input_2}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group flex flex-col">
                      <label
                        className="uppercase text-15 font-600 mb-[7px]"
                        htmlFor="email"
                      >
                        Email Address<span className="text-red-100">*</span>
                      </label>
                      <input
                        id="email"
                        type="email"
                        value={form.input_4}
                        onBlur={(e) => {
                          var value = e.target.value;
                          var pattern =
                            /^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                          if (!pattern.test(value)) {
                            setForm({ ...form, input_4: "" });
                            setFormError({
                              ...formError,
                              input_4: "Please enter valid email.",
                            });
                          }
                        }}
                        onChange={(e) => {
                          setForm({
                            ...form,
                            input_4: e.target.value,
                          });
                          setFormError({
                            ...formError,
                            input_4: "",
                          });
                        }}
                        placeholder="Type here"
                      />
                      {formError.input_4 && (
                        <div className="error">
                          <span className="text-red-100 font-heading italic text-12">
                            {formError.input_4}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group flex flex-col">
                      <label
                        className="uppercase text-15 font-600 mb-[7px]"
                        htmlFor="Message"
                      >
                        Message<span className="text-red-100">*</span>
                      </label>
                      <textarea
                        name=""
                        id="Message"
                        placeholder="Type here"
                        className="resize-none"
                        value={form.input_7}
                        onChange={(e) => {
                          setForm({
                            ...form,
                            input_7: e.target.value,
                          });
                          setFormError({
                            ...formError,
                            input_7: "",
                          });
                        }}
                      ></textarea>
                      {formError.input_7 && (
                        <div className="error relative">
                          <span className="text-red-100 font-heading italic text-12">
                            {formError.input_7}
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <motion.div variants={animFade}>
                        {isButtonVisible && (
                          <button
                            className="uppercase cursor-pointer relative z-9 btn btn-grey"
                            onClick={() => {
                              var validRegex =
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                              setFormError({
                                ...formError,
                                input_2:
                                  form.input_2 === ""
                                    ? "Please enter name."
                                    : "",
                                input_4:
                                  form.input_4 === "" ||
                                  !form.input_4.match(validRegex)
                                    ? "Please enter valid email address."
                                    : "",
                                input_7:
                                  form.input_7 === ""
                                    ? "Please enter message."
                                    : "",
                              });

                              if (
                                form.input_2 !== "" &&
                                form.input_4 !== "" &&
                                form.input_7 !== ""
                              ) {
                                document.body.classList.add("loader");
                                setIsLoading(true);
                                const requestOptions = {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                  body: JSON.stringify(form),
                                };
                                const url = `${process.env.GATSBY_SITE_URL}wp-json/gf/v2/forms/${process.env.GATSBY_GETIN_TOUCH_FORM_ID}/submissions`;
                                setFormError({
                                  ...formError,
                                });
                                fetch(url, requestOptions).then((response) => {
                                  if (response.status === 200) {
                                    document.body.classList.remove("loader");
                                    setIsLoading(false);
                                    navigate("/thank-you")
                                    setForm({
                                      input_2: "",
                                      input_4: "",
                                      input_7: "",
                                    });
                                    setIsButtonVisible(false);
                                  } else {
                                    setFormError({
                                      ...formError,
                                    });
                                  }
                                });
                              }
                            }}
                          >
                            {isLoading ? "Loading" : "SEND ENQUIRY"}
                          </button>
                        )}
                      </motion.div>
                      <div className="get-in-touch-form mt-10"></div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.section>
    );
  }
  return null;
};

export default GetInTouch;
export const PageGetInTouchFragment = graphql`
  fragment PageGetInTouchFragment on WpPage_Pagecontent_PageContent_GetInTouch {
    extraClass
    extraId
    hideSection
    heading
    description
    image {
      altText
      mediaItemUrl
      title
    }
  }
`;
